import React from 'react';
import { Card } from '../ui/Card';
import { AlertCircle, XCircle, Brain, BatteryWarning } from 'lucide-react';
export function Problem() {
  return <section className="py-12 md:py-24 px-4 bg-slate-950 relative" data-id="element-100">
      <div className="max-w-5xl mx-auto space-y-10 md:space-y-20" data-id="element-101">
        {/* The Reality Check */}
        <div className="text-center space-y-6" data-id="element-102">
          <h2 className="text-3xl md:text-4xl font-serif text-amber-50" data-id="element-103">
            Esto no es "insomnio normal". Es un episodio.
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto" data-id="element-104">
            Si estás en perimenopausia, hay noches donde tu cuerpo se despierta
            como si hubiera una alarma interna. Y en ese minuto exacto se decide
            todo: si vuelves a dormir o si entras en el espiral.
          </p>
        </div>

        {/* The Silent Struggle Grid */}
        <div className="grid md:grid-cols-2 gap-8" data-id="element-105">
          <Card className="space-y-4" data-id="element-106">
            <div className="flex items-center gap-3 text-amber-400 mb-2" data-id="element-107">
              <Brain className="w-6 h-6" data-id="element-108" />
              <h3 className="text-xl font-semibold text-slate-100" data-id="element-109">
                Lo que piensas
              </h3>
            </div>
            <ul className="space-y-3 text-slate-300" data-id="element-110">
              <li className="flex gap-3" data-id="element-111">
                <span className="text-slate-500" data-id="element-112">"</span>
                No puede ser otra vez.
              </li>
              <li className="flex gap-3" data-id="element-113">
                <span className="text-slate-500" data-id="element-114">"</span>
                Mañana no voy a funcionar en la reunión.
              </li>
              <li className="flex gap-3" data-id="element-115">
                <span className="text-slate-500" data-id="element-116">"</span>
                ¿Por qué mi cuerpo me hace esto?
              </li>
              <li className="flex gap-3" data-id="element-117">
                <span className="text-slate-500" data-id="element-118">"</span>
                Todo el mundo duerme menos yo.
              </li>
            </ul>
          </Card>

          <Card className="space-y-4" data-id="element-119">
            <div className="flex items-center gap-3 text-red-400 mb-2" data-id="element-120">
              <BatteryWarning className="w-6 h-6" data-id="element-121" />
              <h3 className="text-xl font-semibold text-slate-100" data-id="element-122">
                Lo que sientes
              </h3>
            </div>
            <ul className="space-y-3 text-slate-300" data-id="element-123">
              <li className="flex gap-3" data-id="element-124">
                <AlertCircle className="w-5 h-5 text-slate-600 shrink-0" data-id="element-125" />
                Soledad a las 3am: "nadie entiende este cansancio".
              </li>
              <li className="flex gap-3" data-id="element-126">
                <AlertCircle className="w-5 h-5 text-slate-600 shrink-0" data-id="element-127" />
                Vergüenza silenciosa: "¿cómo voy a estar así si solo es
                dormir?".
              </li>
              <li className="flex gap-3" data-id="element-128">
                <AlertCircle className="w-5 h-5 text-slate-600 shrink-0" data-id="element-129" />
                Miedo práctico: rendir mal, engordar, discutir, llorar fácil.
              </li>
            </ul>
          </Card>
        </div>

        {/* Why Old Solutions Fail */}
        <div className="space-y-6 md:space-y-10 pt-6 md:pt-10 border-t border-slate-900" data-id="element-130">
          <h3 className="text-2xl md:text-3xl font-serif text-center text-slate-200" data-id="element-131">
            Por qué lo que ya probaste te dejó igual (o peor)
          </h3>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-132">
            <div className="space-y-3 p-4" data-id="element-133">
              <div className="w-12 h-12 rounded-full bg-slate-900 flex items-center justify-center text-slate-500 mb-4" data-id="element-134">
                <span className="font-serif text-xl" data-id="element-135">1</span>
              </div>
              <h4 className="text-lg font-semibold text-amber-100" data-id="element-136">
                Suplementos al azar
              </h4>
              <p className="text-slate-400 text-sm leading-relaxed" data-id="element-137">
                A veces ayudan. Pero incluso si ayudan… ¿qué haces cuando igual
                te despiertas a las 3am activada?
              </p>
            </div>

            <div className="space-y-3 p-4" data-id="element-138">
              <div className="w-12 h-12 rounded-full bg-slate-900 flex items-center justify-center text-slate-500 mb-4" data-id="element-139">
                <span className="font-serif text-xl" data-id="element-140">2</span>
              </div>
              <h4 className="text-lg font-semibold text-amber-100" data-id="element-141">
                Quedarte peleando
              </h4>
              <p className="text-slate-400 text-sm leading-relaxed" data-id="element-142">
                Parece lógico quedarte quieta. Pero cuando estás activada, tu
                cerebro aprende una asociación peligrosa: "cama = alerta".
              </p>
            </div>

            <div className="space-y-3 p-4" data-id="element-143">
              <div className="w-12 h-12 rounded-full bg-slate-900 flex items-center justify-center text-slate-500 mb-4" data-id="element-144">
                <span className="font-serif text-xl" data-id="element-145">3</span>
              </div>
              <h4 className="text-lg font-semibold text-amber-100" data-id="element-146">
                Pantallas y "distracción"
              </h4>
              <p className="text-slate-400 text-sm leading-relaxed" data-id="element-147">
                "Solo me distraigo tantito". Y de pronto son las 4:11. Luz +
                estímulo + emoción = más activación.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center max-w-2xl mx-auto bg-amber-950/20 border border-amber-900/30 rounded-xl p-8" data-id="element-148">
          <p className="text-lg md:text-xl text-amber-200/90 font-medium" data-id="element-149">
            "La mayoría pierde no porque sea débil. Pierde porque improvisa."
          </p>
        </div>
      </div>
    </section>;
}